import { render, staticRenderFns } from "./topItem.vue?vue&type=template&id=79823502&scoped=true&"
import script from "./topItem.vue?vue&type=script&lang=js&"
export * from "./topItem.vue?vue&type=script&lang=js&"
import style0 from "./topItem.vue?vue&type=style&index=0&id=79823502&prod&lang=scss&scoped=true&"
import style1 from "./topItem.vue?vue&type=style&index=1&id=79823502&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79823502",
  null
  
)

export default component.exports